import ToastEventBus from 'primevue/toasteventbus'
import { useI18n } from 'vue-i18n'
import type { TGymAccessCheckIn } from '../api/queries'
import { playGymAccessDenySound } from './playGymAccessDenySound'

export const GYM_ACCESS_TOAST_GROUP = 'gymAccess'
export const GYM_ACCESS_TOAST_LIFE_MS = 10_000

export function useGymAccessToast() {
  const { t } = useI18n()

  const showAccessResult = (result: TGymAccessCheckIn): void => {
    if (result.tone === 'danger') {
      playGymAccessDenySound()
    }

    const severity =
      result.tone === 'success'
        ? 'success'
        : result.tone === 'info'
          ? 'info'
          : 'error'

    ToastEventBus.emit('add', {
      severity,
      group: GYM_ACCESS_TOAST_GROUP,
      life: GYM_ACCESS_TOAST_LIFE_MS,
      closable: true,
      summary: result.allowed
        ? t('gym.ACCESS_ALLOWED')
        : t('gym.ACCESS_DENIED'),
      accessResult: result,
    })
  }

  return { showAccessResult }
}
